module.exports = "/images/cc.svg?ff51751fe198a0cc69fa7f2d7d29fdab";